// Package
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true,
            default: ""
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        name: {
            type: String,
            required: true,
            default: ""
        },
        errors: {
            type: Object,
            required: false,
            default: ()=>{},
        },
        col:{
            type: String,
            required: false,
            default: "12",
        },
        required:{
            type: Boolean,
            required: false,
            default: false,
        },
        information:{
            type: String,
            required: false,
            default: null,
        },
        rows:{
            type: String,
            required: false,
            default: 3,
        },
        value: {
            type: String | null,
            required: false,
            default: ""
        },
    }
})